import {useParams, useNavigate} from 'react-router-dom';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {DetailPageNavigation} from '../navigation/DetailPageNavigation';
import {useReportType} from '../hooks/useReportType';
import {Button} from '@mantine/core';

export const DetailPage = () => {

    const {id: componentId} = useParams();
    const navigate = useNavigate();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        loading,
    } = useReportType(componentId);

    const tools = [
        <Button key='close' variant='default' onClick={() => navigate('/report-types')}>Close</Button>
    ];

    if (loading || !component) {
        return <PlatformLoader message='Loading report type...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={component.name ? component.name : component.id}
            pageNavigation={<DetailPageNavigation component={component}/>}
            tools={tools}
        >
            <Profile record={component}/>
        </FormPageLayout>
    );
};
